import { ComponentType } from '@angular/cdk/portal'
import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { BrandingService } from 'libs/gb-front/auction/branding/src/lib/branding.service'
import { GbBaseDialogService, GbDialogConfig } from 'libs/shared/utils/dialogs/src'

@Injectable({
  providedIn: 'root',
})
export class GbFrontDialogService extends GbBaseDialogService {
  get isDarkTheme(): boolean {
    return this.brandingService.theme === 'dark'
  }

  constructor(protected matDialog: MatDialog, private brandingService: BrandingService) {
    super(matDialog)
  }

  openDialog(component: ComponentType<any>, dialogConfig?: GbDialogConfig) {
    return super.openDialog(component, {
      ...dialogConfig,
      panelClass: this.getPanelClasses(dialogConfig),
    })
  }

  getDialogObs(component: ComponentType<any>, dialogConfig?: GbDialogConfig) {
    return super.getDialogObs(component, {
      ...dialogConfig,
      panelClass: this.getPanelClasses(dialogConfig),
    })
  }

  private getPanelClasses(dialogConfig?: GbDialogConfig) {
    const panelClasses = this.isDarkTheme ? ['gb-dark-theme'] : []
    if (dialogConfig?.panelClass) {
      panelClasses.push(
        ...(Array.isArray(dialogConfig.panelClass) ? dialogConfig.panelClass : [dialogConfig.panelClass]),
      )
    }
    return panelClasses
  }
}
